import { Controller } from "@hotwired/stimulus"

// Reveals the DataTable's loading overlay while a quick-filter link runs a
// full-page Turbo Drive visit (data-turbo-frame="_top", chosen so out-of-frame
// toolbar controls re-render in sync). Such a visit never stamps [busy] on the
// table frame, so the overlay (turbo-frame[busy] .cup-table-busy) would stay
// hidden behind the top progress bar. Attached to the frame, this stamps [busy]
// on click — reusing the same signal a frame navigation emits, so the overlay
// reveals and the toolbar dims (filters_controller) exactly as for other filters.
// The visit's fresh render clears it; we also clear before caching so a
// back-navigation snapshot isn't frozen mid-load.
export default class extends Controller {
  connect() {
    this.clear = () => this.element.removeAttribute("busy")
    document.addEventListener("turbo:before-cache", this.clear)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.clear)
  }

  show() {
    this.element.setAttribute("busy", "")
  }
}
